import { APP_API_BASE } from "./apiConfig";

const ADMIN_TOKEN_KEY = "finpilot_admin_token";

export const getAdminToken = () => window.localStorage.getItem(ADMIN_TOKEN_KEY);

export const setAdminToken = (token) => {
  window.localStorage.setItem(ADMIN_TOKEN_KEY, token);
};

export const clearAdminToken = () => {
  window.localStorage.removeItem(ADMIN_TOKEN_KEY);
};

const adminHeaders = () => {
  const token = getAdminToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const adminLogin = async ({ login, password }) => {
  const response = await fetch(`${APP_API_BASE}/api/admin/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ login, password }),
  });
  const json = await response.json();
  if (!response.ok) {
    throw new Error(json.detail || "Přihlášení selhalo");
  }
  return json;
};

export const fetchAdminDashboard = async () => {
  const response = await fetch(`${APP_API_BASE}/api/admin/dashboard`, {
    headers: {
      ...adminHeaders(),
    },
  });
  const json = await response.json();
  if (!response.ok) {
    throw new Error(json.detail || "Nepodařilo se načíst administraci");
  }
  return json;
};

export const updateAdminUser = async ({
  userId,
  creditsDelta = 0,
  blocked = null,
  email = null,
  confirmLogin = null,
  confirmPassword = null,
}) => {
  const response = await fetch(`${APP_API_BASE}/api/admin/users/${userId}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      ...adminHeaders(),
    },
    body: JSON.stringify({
      credits_delta: creditsDelta,
      blocked,
      email,
      confirm_login: confirmLogin,
      confirm_password: confirmPassword,
    }),
  });
  const json = await response.json();
  if (!response.ok) {
    throw new Error(json.detail || "Nepodařilo se upravit uživatele");
  }
  return json;
};
